import { createEvent } from 'effector';

export const setPayoutNewOrdersCount = createEvent<number>();
